import { createSelector } from 'reselect';
import {
    CREATE_APPLICATION,
    CREATE_APPLICATION_SUCCESS,
    CREATE_APPLICATION_FAILURE,
    RESET_CREATE_APPLICATION
} from './createApplicationActions';

const initialState = {
    isCreating: false,
    error: null,
    createSuccess: false,
    applicationId: null,
    applicationData: null,
    onboardingId: null
};

export default function createApplicationReducer(state = initialState, action = {}) {
    let newState;

    switch (action.type) {
        case CREATE_APPLICATION:
            newState = {
                ...state,
                isCreating: true,
                error: null,
                createSuccess: false
            };

            return newState;

        case CREATE_APPLICATION_SUCCESS: {
            let applicationId = null;
            let applicationData = null;
            let onboardingId = null;

            if (action.response) {
                applicationData = action.response;
                applicationId = action.response.id || action.response.merchantAppId || null;
                onboardingId = action.response.onboardingId || null;
            }

            newState = {
                ...state,
                isCreating: false,
                error: null,
                createSuccess: true,
                applicationId: applicationId,
                applicationData: applicationData,
                onboardingId: onboardingId
            };

            return newState;
        }

        case CREATE_APPLICATION_FAILURE:
            newState = {
                ...state,
                isCreating: false,
                error: action.error,
                createSuccess: false
            };

            return newState;

        case RESET_CREATE_APPLICATION:
            return initialState;

        default:
            return state;
    }
}

const getCreateApplicationState = (state) => {
    return state.entities?.createApplication || initialState;
};

export const getIsCreatingApplication = createSelector(
    [getCreateApplicationState],
    (createApplicationState) => createApplicationState.isCreating
);

export const getCreateApplicationError = createSelector(
    [getCreateApplicationState],
    (createApplicationState) => createApplicationState.error
);

export const getCreateApplicationSuccess = createSelector(
    [getCreateApplicationState],
    (createApplicationState) => createApplicationState.createSuccess
);

export const getCreateApplicationId = createSelector(
    [getCreateApplicationState],
    (createApplicationState) => createApplicationState.applicationId
);

export const getCreateApplicationData = createSelector(
    [getCreateApplicationState],
    (createApplicationState) => createApplicationState.applicationData
);

export const getOnboardingId = createSelector(
    [getCreateApplicationState],
    (createApplicationState) => createApplicationState.onboardingId
);
